import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './DashboardPage.css';

const DashboardPage = () => {
  const { user } = useAuth();

  const stats = [
    {
      label: '角色',
      value: user?.roles_info?.length || 0,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      color: 'primary',
    },
    {
      label: '权限',
      value: user?.permissions?.length || 0,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      ),
      color: 'success',
    },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div className="dashboard-welcome">
          <h1>欢迎回来，{user?.real_name || user?.username}！</h1>
          <p>今天是 {new Date().toLocaleDateString('zh-CN', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}</p>
        </div>
      </div>

      <div className="dashboard-stats">
        {stats.map((stat, index) => (
          <div
            key={stat.label}
            className={`stat-card stat-${stat.color}`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-content">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-content">
        <div className="dashboard-card profile-card">
          <h3 className="card-title">个人信息</h3>
          <div className="profile-info">
            <div className="profile-avatar">
              {user?.avatar ? (
                <img src={user.avatar} alt="头像" />
              ) : (
                <span>{(user?.real_name || user?.username || 'U')[0].toUpperCase()}</span>
              )}
            </div>
            <div className="profile-details">
              <div className="profile-item">
                <span className="profile-label">用户名</span>
                <span className="profile-value">{user?.username}</span>
              </div>
              <div className="profile-item">
                <span className="profile-label">姓名</span>
                <span className="profile-value">{user?.real_name || '-'}</span>
              </div>
              <div className="profile-item">
                <span className="profile-label">工号</span>
                <span className="profile-value">{user?.employee_id || '-'}</span>
              </div>
              <div className="profile-item">
                <span className="profile-label">部门</span>
                <span className="profile-value">{user?.department_name || '-'}</span>
              </div>
              <div className="profile-item">
                <span className="profile-label">邮箱</span>
                <span className="profile-value">{user?.email || '-'}</span>
              </div>
              <div className="profile-item">
                <span className="profile-label">手机</span>
                <span className="profile-value">{user?.phone || '-'}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-card roles-card">
          <h3 className="card-title">我的角色</h3>
          <div className="roles-list">
            {user?.roles_info?.length > 0 ? (
              user.roles_info.map((role) => (
                <div key={role.id} className="role-item">
                  <div className="role-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    </svg>
                  </div>
                  <div className="role-info">
                    <span className="role-name">{role.name}</span>
                    <span className="role-desc">{role.description || '暂无描述'}</span>
                  </div>
                </div>
              ))
            ) : (
              <p className="empty-text">暂无角色</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;

